import { render, staticRenderFns } from "./indexNewsList.vue?vue&type=template&id=2bd6150b&scoped=true"
import script from "./indexNewsList.vue?vue&type=script&lang=js"
export * from "./indexNewsList.vue?vue&type=script&lang=js"
import style1 from "./indexNewsList.vue?vue&type=style&index=1&id=2bd6150b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd6150b",
  null
  
)

export default component.exports